import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export function PickerSubheaderUniDriver(base: UniDriver, _: UniDriver) {
  const getSearch = () => base.$('[data-hook="collection-search"]');
  return {
    ...baseUniDriverFactory(base),
    enterSearchTerm: (value: string) => getSearch().enterValue(value),
  };
}
